import { crmRoutes } from '@rematter/modules/crm/routes';
import { atom } from 'jotai';

import { accountsQueryAtom, AddressRecord } from '../_graphql/queryAccounts';
import { paymentTermConfigsQueryAtom } from '../_graphql/queryPaymentTerms';
import { AccountDetailsTab } from '../types';

import { atomFromQueryString, atomFromRoutePath } from '~/shared/state';

// 🟣🟣🟣 PARAMS
const $detailsPathParams = atomFromRoutePath(crmRoutes.accountDetails);
export const $selectedAddressId = atomFromQueryString.string('addressId');
export const $searchTerm = atomFromQueryString.string('searchTerm');
export const $tab = atomFromQueryString.string<AccountDetailsTab>(
  'tab',
  'details',
);

// 🟢🟢🟢 COMPUTED DATA -> account ID
export const $accountId = atom((get) =>
  String(get($detailsPathParams)?.accountId),
);

// 🟢🟢🟢 REMOTE DATA
export const $remoteAccount = accountsQueryAtom((get) => ({
  variables: {
    accountIds: [get($accountId)],
  },
  skip: !get($accountId),
}));

// 🟢🟢🟢 COMPUTED DATA -> selected account
export const $selectedAccount = atom((get) =>
  get($remoteAccount).data?.accounts.at(0),
);

// 🟢🟢🟢 COMPUTED DATA -> selected address
export const $selectedAddress = atom(
  (get) => {
    const selectedAddressId = get($selectedAddressId);
    const addresses = get($selectedAccount)?.addresses;

    return selectedAddressId
      ? addresses?.find((address) => address.id === selectedAddressId)
      : addresses?.at(0);
  },
  (_get, set, address: AddressRecord | undefined) => {
    set($selectedAddressId, address?.id);
  },
);

// 🟢🟢🟢 COMPUTED DATA -> should disable deletion
export const $shouldDisableDeletion = atom(
  (get) => get($selectedAccount)?.addresses.length === 1,
);

// 🟢🟢🟢 COMPUTED DATA -> filtered addresses
export const $filteredAddresses = atom((get) => {
  const searchTerm = get($searchTerm)?.toLowerCase().trim();

  return get($selectedAccount)?.addresses.filter(
    (address) =>
      !searchTerm ||
      address.name?.toLowerCase().includes(searchTerm) ||
      address.streetAddress?.toLowerCase().includes(searchTerm) ||
      address.city?.toLowerCase().includes(searchTerm) ||
      address.state?.toLowerCase().includes(searchTerm),
  );
});

// 🟢🟢🟢 COMPUTED DATA -> address contacts
export const $addressContacts = atom(
  (get) => get($selectedAddress)?.contacts ?? [],
);

// 🟢🟢🟢 REMOTE DATA -> payment term configs
export const $paymentTermConfigs = paymentTermConfigsQueryAtom(() => ({}));
